import React from 'react'
import queryString from 'query-string'
import { Form, Progress } from 'reactstrap'
import { CSSTransition } from 'react-transition-group'

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.parameters = queryString.parse(props.location.search)
    this.parameters.idp = 'entel';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    }
  }

  componentDidMount() {
    this.setState({ showForm: true })
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    })
  }

  async onSubmit(ev) {
    ev.preventDefault()

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    })



    this.props.api
      .userPassLogin(
        {
          username: this.usernameInput.value.toUpperCase(),
          password: this.passwordInput.value
        },
        this.parameters
      )
      .then(response => {
        this.setState({ onLogin: false })
        window.location =
          this.parameters.redirect_uri + '?' + queryString.stringify(response)
      })
      .catch(error => {

        const translate = this.props.translate(error.errorCode)

        let message = <p className='error'>Para acceder a este contenido le invitamos a contratar este canal y a registrarse en Mi Entel Hogar ingresando <a href="http://www.entel.cl/login/hogar">aquí</a> </p>

        if (translate) {
          message = translate
        } else if (error.details) {
          message = error.details
        }

        this.setState({
          onLogin: false,
          error: { open: true, message: message }
        })
      });
  }

  render() {
    const { translate } = this.props

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames='formshow'
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className='container' ref={this.ref}>
          <div className='row'>
            <div className='col-xs-12'>
              <div className='contentLogin'>
                <h1>
                  Utiliza tu RUT y clave de <span>Mi Entel_HOGAR</span>
                </h1>
                <Form onSubmit={event => this.onSubmit(event)}>
                  <div className='row'>
                    <div className='col-xs-6 col-sm-6 col-lg-6'>
                      <div className='form-group'>
                        <label >RUT_</label>
                        <input
                          className='form-control ancho'
                          disabled={this.state.onLogin}
                          ref={ref => {
                            this.usernameInput = ref
                          }}
                          required={true}
                          tabIndex={1}
                          type='text'
                          autoCorrect='off'
                          autoCapitalize='none'
                          name='username'
                        />
                        <p className='ej'>Ej: 12345678-k</p>
                      </div>
                    </div>
                    <div className='col-xs-6 col-sm-6 col-lg-6'>
                      <div className='form-group'>
                        <label for='password'>Clave_</label>
                        <input
                          className='form-control ancho'
                          required={true}
                          disabled={this.state.onLogin}
                          ref={ref => {
                            this.passwordInput = ref
                          }}
                          tabIndex={1}
                          type='password'
                          autoCorrect='off'
                          autoCapitalize='none'
                          name='password'
                        />
                      </div>
                    </div>

                    <div className='col-sm-4 col-lg-4'></div>
                    <div className='col-sm-4 col-lg-4'>
                      <div className='entel-btn-login'>
                        {!this.state.onLogin ? (
                          <button
                            block={!this.parameters.failureRedirect}
                            tabIndex={1}
                            className=''
                            type='submit'
                            name='submit'
                            disabled={!this.props.turnstileSuccess}
                          >
                            {translate('Ingresar')}
                          </button>
                        ) : (
                          <Progress animated color='danger' value={100} />
                        )}
                      </div>

                      <ul>
                        <li className='entel-link-left'>
                          <a href='https://miperfil.entel.cl/MiEntel/ForgotPassword.aspx'>
                            Recuperar clave
                          </a>
                        </li>
                        {
                          checkDeviceIOS() ? '' : <li className='entel-link-rigth'>
                            <a href='https://miperfil.entel.cl/MiEntel/PersonalData.aspx'>
                              Registrarme
                            </a>
                          </li>
                        }
                      </ul>
                      <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
                    </div>
                    <div className='col-sm-4 col-lg-4'></div>


                    <div className='col-sm-1 col-lg-1'></div>

                    <div className='col-xs-12 col-sm-10 col-lg-10'>
                      <div className='messages-container'>
                        <span className='entel-error'>
                          {this.state.error.message}
                        </span>
                      </div>
                    </div>
                    <div className='col-sm-1 col-lg-1'></div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    )
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
